import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import type { InputTextareaProps } from "primereact/inputtextarea";

interface TextAreaProps extends Omit<InputTextareaProps, "className" | "rows"> {
  parentClass?: string;
  className?: string;
  classes?: string;
  label?: React.ReactNode;
  labelOn?: boolean;
  error?: string;
  rows?: number | string;
  explanation?: React.ReactNode;
}

export default function TextArea(props: TextAreaProps) {
  const {
    parentClass,
    className,
    classes,
    label,
    labelOn,
    name,
    onChange,
    value,
    error,
    rows,
    explanation,
    ...other
  } = props;

  return (
    <div className={parentClass || undefined}>
      {labelOn ? (
        <div className="mb-2">
          <label htmlFor={name} className="block text-sm font-medium text-gray-900">
            {label}
          </label>
        </div>
      ) : null}
      <div className="mt-1">
        <InputTextarea
          name={name}
          value={value}
          onChange={onChange}
          rows={rows == null ? undefined : Number(rows)}
          className={classes || className || "w-full"}
          {...other}
        />
        {error ? <p className="font-medium text-red-500 mt-1">{error}</p> : null}
      </div>
    </div>
  );
}
